export default class SearchLightbox {
  constructor() {
    this.$lightbox = $('#search-lightbox')
    this.$backdrop = $('.search-lightbox-backdrop')
    this.$closeBtn = $('.search-lightbox-close')
    this.$searchInput = $('.search-input')
    this.$searchToggle = $('.search-toggle')
    this.$searchForm = $('.search-form')
    this.isOpen = false
  }

  init() {
    if (this.$lightbox.length) {
      this.bindEvents()
    }
  }

  bindEvents() {
    // Open lightbox
    this.$searchToggle.on('click', (e) => {
      e.preventDefault()
      this.open()
    })

    // Close on backdrop click
    this.$backdrop.on('click', () => this.close())

    // Close on close button
    this.$closeBtn.on('click', () => this.close())

    // Close on ESC key
    $(document).on('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close()
      }
    })

    // Handle form submission
    this.$searchForm.on('submit', (e) => {
      // e.preventDefault()
      // const query = this.$searchInput.val()
      // if (query.trim()) {
      //   this.handleSearch(query)
      // }
    })

    // Focus trap
    this.$lightbox.on('keydown', (e) => this.trapFocus(e))
  }

  open() {
    this.$lightbox.addClass('is-open')
    this.$lightbox.attr('aria-hidden', 'false')
    $('body').addClass('search-lightbox-open')
    this.isOpen = true
    
    // Focus on input after animation
    setTimeout(() => {
      this.$searchInput.focus()
    }, 300)
  }

  close() {
    this.$lightbox.removeClass('is-open')
    this.$lightbox.attr('aria-hidden', 'true')
    $('body').removeClass('search-lightbox-open')
    this.isOpen = false
    this.$searchInput.val('')
  }

  trapFocus(e) {
    // Implementation for focus trapping
    if (e.key === 'Tab') {
      const focusableElements = this.$lightbox.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      const firstElement = focusableElements.first()
      const lastElement = focusableElements.last()

      if (e.shiftKey && $(document.activeElement).is(firstElement)) {
        e.preventDefault()
        lastElement.focus()
      } else if (!e.shiftKey && $(document.activeElement).is(lastElement)) {
        e.preventDefault()
        firstElement.focus()
      }
    }
  }

  handleSearch(query) {
    // Placeholder - integrate with your search logic
    console.log('Search query:', query)
    // Example: Redirect to search results page
    // window.location.href = `/search?q=${encodeURIComponent(query)}`
    
    // For now, just close the lightbox
    this.close()
  }
}

new SearchLightbox().init()
